import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import tokenStore from '@store/tokenStore'
import authStore from '@store/authStore'
import companiesStore from '@store/companiesStore'
import downloadsStore from '@store/downloadsStore'
import exportsStore from '@store/exportsStore'
import membersStore from '@store/membersStore'
import reportsStore from '@store/reportsStore'
import tagsStore from '@store/tagsStore'
import rolesStore from '@store/rolesStore'
import bdxManagementStore from './bdxManagementStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    token: tokenStore,
    auth: authStore,
    companies: companiesStore,
    downloads: downloadsStore,
    exports: exportsStore,
    members: membersStore,
    reports: reportsStore,
    tags: tagsStore,
    roles: rolesStore,
    bdxManagement: bdxManagementStore
  },
  plugins: [createPersistedState()]
})
